import BASE_RULE from '../baseRule';
import {CategoryType, SearchTypeCategoryId} from './constants';
import {CategoryIdRule} from './types';

export const categoryIdRuleDefaults: CategoryIdRule = {
	...BASE_RULE,
	elementType: SearchTypeCategoryId,
	elementSubType1: CategoryType.ONLY,
	/** top level */
	elementValue1: 1,
};

export default categoryIdRuleDefaults;
